'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Spinner = require('@icare/components/lib/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _isContentMap = function _isContentMap(n) {
	return n && (typeof n === 'undefined' ? 'undefined' : _typeof(n)) === 'object' && typeof n.inject === 'string' && typeof n.as === 'string';
};

var _isContentComputed = function _isContentComputed(n) {
	return n && typeof n === 'function';
};

var _isContentId = function _isContentId(n) {
	return n && typeof n === 'string';
};

/**
 * WithContent is a HOC that is responsible for injecting a given
 * component with the content it requires. It works by creating a new
 * component and using that component to ask the content store for all
 * the required data. It then provides that data as props to the original
 * component.
 * @param {ReactNode}      Component      - the component we wish to inject into
 * @param {Array<String>}  contentIds     - An array of content ID strings, mapping to the keys of the content store object
 * @param {Array<String>}  contentAreaIds - An array of content area ID strings, mapping to the keys of the content store object
 */
var withContent = function withContent(Component, contentIds) {
	var _class, _temp;

	var contentAreaIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

	return (0, _mobxReact.inject)('contentStore')((_temp = _class = function (_React$Component) {
		_inherits(ComponentWithContent, _React$Component);

		function ComponentWithContent(props) {
			_classCallCheck(this, ComponentWithContent);

			var _this = _possibleConstructorReturn(this, (ComponentWithContent.__proto__ || Object.getPrototypeOf(ComponentWithContent)).call(this, props));

			_this._updateContent = function () {
				_this.updateContent();
			};

			_this._forceUpdateContent = function () {
				_this.props.contentStore.clearContent();
				_this.updateContent();
			};

			var contentIdMaps = contentIds.filter(function (c) {
				return _isContentMap(c);
			});
			var contentAreaMaps = contentAreaIds.filter(function (c) {
				return _isContentMap(c);
			});

			_this._contentMaps = [].concat(_toConsumableArray(contentIdMaps), _toConsumableArray(contentAreaMaps));

			_this._contentIds = [].concat(_toConsumableArray(contentIds.filter(function (c) {
				return _isContentId(c);
			})), _toConsumableArray(contentIdMaps.map(function (m) {
				return m.inject;
			})));
			_this._computed = contentIds.filter(function (c) {
				return _isContentComputed(c);
			});

			_this._contentAreaIds = [].concat(_toConsumableArray(contentAreaIds.filter(function (ca) {
				return _isContentId(ca);
			})), _toConsumableArray(contentAreaMaps.map(function (m) {
				return m.inject;
			})));
			_this._computedContentAreas = contentAreaIds.filter(function (ca) {
				return _isContentComputed(ca);
			});

			_this.state = {
				isLoading: true,
				content: null
			};
			return _this;
		}

		_createClass(ComponentWithContent, [{
			key: 'updateContent',
			value: function () {
				var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
					var _this2 = this;

					var contentStore, contentMaps, ids, caIds;
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									contentStore = this.props.contentStore;

									// Clone these so we are not mutating originals

									contentMaps = [].concat(_toConsumableArray(this._contentMaps));
									ids = [].concat(_toConsumableArray(this._contentIds));
									caIds = [].concat(_toConsumableArray(this._contentAreaIds));

									// Iterate all computed content

									this._computed.forEach(function (c) {
										(function process(result) {
											if (Array.isArray(result)) {
												result.forEach(function (item) {
													return process(item);
												});
											} else {
												if (_isContentMap(result)) {
													// If a map, hold onto the map and continue to load the underlying id
													contentMaps.push(result);
													ids.push(result.inject);
												} else if (_isContentId(result)) {
													// If an id, so load it as per normal
													ids.push(result);
												} else {
													if (result !== null) {
														console.error('Invalid result. Check the return statement of your computed content function.', c);
													}
												}
											}
										})(c.call(Component, _this2.props, contentIds, contentAreaIds));
									});

									// Iterate all computed content areas
									this._computedContentAreas.forEach(function (c) {
										(function process(result) {
											if (Array.isArray(result)) {
												result.forEach(function (item) {
													return process(item);
												});
											} else {
												if (_isContentMap(result)) {
													// If a map, hold onto the map and continue to load the underlying id
													contentMaps.push(result);
													caIds.push(result.inject);
												} else if (_isContentId(result)) {
													// If an id, so load it as per normal
													caIds.push(result);
												} else {
													if (result !== null) {
														console.error('Invalid result. Check the return statement of your computed content area function.', c);
													}
												}
											}
										})(c.call(Component, _this2.props, contentIds, contentAreaIds));
									});

									_context.next = 8;
									return contentStore.loadContent(ids, caIds);

								case 8:

									this.setState({
										isLoading: false,
										content: _extends({}, contentStore.getFlattenedContentForIds([].concat(_toConsumableArray(ids), _toConsumableArray(caIds)), contentMaps), {
											update: this._updateContent,
											forceUpdate: this._forceUpdateContent
										})
									});

								case 9:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this);
				}));

				function updateContent() {
					return _ref.apply(this, arguments);
				}

				return updateContent;
			}()
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateContent();
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.isLoading) {
					return _react2.default.createElement(
						'div',
						{ style: { paddingTop: '60px' } },
						_react2.default.createElement(_Spinner2.default, { active: true })
					);
				}

				return _react2.default.createElement(Component, _extends({ content: this.state.content }, this.props));
			}
		}]);

		return ComponentWithContent;
	}(_react2.default.Component), _class.propTypes = {
		contentStore: _propTypes2.default.object.isRequired
	}, _temp));
};

exports.default = withContent;
//# sourceMappingURL=withContent.js.map